import React from 'react';
import { createClassName } from 'utils/createClassName';

import './spinnerExtraLargeStyles.scss';

export const SpinnerExtraLarge = () => {
  const className = createClassName('spinnerExtraLarge')();

  return (
    <div className={className}>
      <div>
        <div>
          <div>
            <div>
              <div>
                <div>
                  <div>
                    <div>
                      <div>
                        <div />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
